import COLORS from "@/features/shared/widgets/graphs/colors";
import type { ParameterTimeSeriesThresholdColor } from "@/lib/api";

/**
 * Threshold color keys map onto the shared graph palette (see graphs/colors.ts):
 * - LINES: saturated color for the horizontal reference line.
 * - PLOTS: light tint for the time band highlighting where values cross the threshold.
 * - POINTS: saturated color for recolored line segments / markers and marker labels.
 */

export function resolveThresholdLineColor(
  color: ParameterTimeSeriesThresholdColor,
): string {
  return COLORS.LINES[color];
}

export function resolveThresholdBandColor(
  color: ParameterTimeSeriesThresholdColor,
): string {
  return COLORS.PLOTS[color];
}

export function resolveThresholdPointColor(
  color: ParameterTimeSeriesThresholdColor,
): string {
  return COLORS.POINTS[color];
}

/** Marker label text uses the saturated point color for legibility on the bubble. */
export const resolveThresholdMarkerTextColor = resolveThresholdPointColor;
